jQuery(function ($) {
	$('button[type="submit"].single_add_to_cart_button').remove();
	var url = kwb_script_vars.url,
		vid = 'input[name="variation_id"]',
		title = kwb_script_vars.title,
		qty = 'input.qty',
		button = 'a.custom-checkout-btn';

	// Once DOM is loaded
	setTimeout(function () {
		if ($(vid).val() != '') {
			$(button).attr('href', url + 'product_title=' + title + '&variation_id=' + $(vid).val() + '&quantity=' + $(qty).val());
		}
	}, 300);

	// On input/change quantity event
	$(qty).on('input change', function () {
		if ($(vid).val() != '') {
			$(button).attr('href', url + 'product_title=' + title + '&variation_id=' + $(vid).val() + '&quantity=' + $(qty).val());
		}
	});

	// On select attribute field change event
	$('.variations_form').on('change blur', 'table.variations select', function () {
		if ($(vid).val() != '') {
			$(button).attr('href', url + 'product_title=' + title + '&variation_id=' + $(vid).val() + '&quantity=' + $(qty).val());
		}
	});
});
